import Immutable from 'immutable';
import {
  COMPETITION_VISIBLE,
  DETAILS_VIEW_ENTER,
  DETAILS_VIEW_LEAVE,
  SET_EVENTS_DAY
} from './actions';

export const InitialState = new Immutable.Record({
  eventsDay: 0,
  currentEventId: null,
  competitionVisibility: new Immutable.Map()
});

export default (state = new InitialState(), action) => {
  const { type } = action;
  switch (type) {
    case DETAILS_VIEW_ENTER: {
      const { eventId } = action;
      if (!eventId.match(/^OB_EV[\d]+$/)) {
        return state;
      }
      return state.set('currentEventId', eventId);
    }
    case DETAILS_VIEW_LEAVE: {
      return state.set('currentEventId', null);
    }
    case SET_EVENTS_DAY: {
      return state
        .set('eventsDay', action.day)
        .set('competitionVisibility', new Immutable.Map());
    }
    case COMPETITION_VISIBLE: {
      const { id, visible } = action;
      return state.setIn(['competitionVisibility', id], visible);
    }
    default: {
      return state;
    }
  }
};
